import axios from 'axios';
import { BASE_URL } from 'constants';
import {
  getToken,
  clearSession,
  markSessionExpired,
} from 'services/auth/tokenService';
import routes from 'routes';

export const defaultApi = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

defaultApi.interceptors.request.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export const authApi = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

authApi.interceptors.request.use(
  (config) => {
    const token = getToken();

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    // Handle the error
    return Promise.reject(error);
  }
);

// Several requests can 401 at once (a dashboard fires many in parallel) — only the first one gets to redirect.
let sessionExpiryHandled = false;

authApi.interceptors.response.use(
  (response) => response,
  (error) => {
    // A 401 on a request that actually carried a token means the server no longer accepts our session — the token
    // expired, or its signing key changed. Permission problems are 403s and stay with the caller; a 401 on a
    // token-less request is ProtectedRoute's job. Hard navigation (not react-router) so every trace of the dead
    // session's React/Redux state is gone when the login page loads.
    if (
      error?.response?.status === 401 &&
      error?.config?.headers?.Authorization &&
      !sessionExpiryHandled
    ) {
      sessionExpiryHandled = true;
      clearSession();
      markSessionExpired();
      window.location.assign(routes.auth.login);
    }
    return Promise.reject(error);
  }
);

export default authApi;
